import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import SelectorRivalEnfrentamientos from './SelectorRivalEnfrentamientos.js';
import TotalesRivales from './TotalesRivales.js';
import TotalesSeleccionRival from './TotalesSeleccionRival.js';
import PartidosSeleccionRival from './PartidosSeleccionRival.js';
import { TituloPagina } from '../funciones/Funciones.js';
import styles from './BaseEnfrentamientos.module.css';

const BaseEnfrentamientos = () => {
  const [searchParams] = useSearchParams();
  const idPais = searchParams.get('pais');
  const [buscarParams, setBuscarParams] = useState(null);
  const [totalesFiltrados, setTotalesFiltrados] = useState(null);

  useEffect(() => {
    document.title = TituloPagina(BaseEnfrentamientos.name);
  }, []);

  const onBuscar = (params) => {
    setTotalesFiltrados(undefined);
    setBuscarParams({ ...params, searchTrigger: Date.now() });
  };

  const onRivalTotalesElegido = (rival) => {
    if (!buscarParams || !rival) return;
    setTotalesFiltrados(undefined);
    setBuscarParams({
      ...buscarParams,
      modoTotales: false,
      rival,
      searchTrigger: Date.now(),
    });
  };

  const onVolverATotales = () => {
    if (!buscarParams) return;
    setTotalesFiltrados(undefined);
    setBuscarParams({
      ...buscarParams,
      modoTotales: true,
      rival: null,
      searchTrigger: Date.now(),
    });
  };

  return (
    <div className={`${styles.columnas}`}>
      <div className={`${styles.columnaSelector}`}>
        <SelectorRivalEnfrentamientos idPais={idPais} onBuscar={onBuscar} />
      </div>

      {buscarParams?.modoTotales && (
        <div className={`${styles.columnaResultados}`}>
          <TotalesRivales
            idPais={idPais}
            tipoRivalId={buscarParams.tipoRivalId}
            categoria={buscarParams.categoria}
            tipoInternacional={buscarParams.tipoInternacional}
            searchTrigger={buscarParams.searchTrigger}
            onRivalElegido={onRivalTotalesElegido}
          />
        </div>
      )}

      {!buscarParams?.modoTotales && buscarParams?.rival && (
        <React.Fragment>
          <div className={`${styles.columnaFiltrosPartidos}`}>
            <PartidosSeleccionRival
              idPais={idPais}
              tipoRivalId={buscarParams.tipoRivalId}
              idRival={buscarParams.rival?.id}
              categoria={buscarParams.categoria}
              tipoInternacional={buscarParams.tipoInternacional}
              searchTrigger={buscarParams.searchTrigger}
              onTotalesFiltradosChange={setTotalesFiltrados}
            />
            <button className={`${styles.botonVolver}`} onClick={onVolverATotales}>
              Volver a la lista
            </button>
          </div>
          <div className={`${styles.columnaTotalesPartidos}`}>
            <TotalesSeleccionRival
              idPais={idPais}
              tipoRivalId={buscarParams.tipoRivalId}
              idRival={buscarParams.rival?.id}
              categoria={buscarParams.categoria}
              tipoInternacional={buscarParams.tipoInternacional}
              searchTrigger={buscarParams.searchTrigger}
              totalesFiltrados={totalesFiltrados}
            />
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default BaseEnfrentamientos;
